import React from 'react';
import {Autocomplete, FormControl, TextField} from '@mui/material';

interface ISelectProps {
    id: number | string;
    name: string;
}

interface ICustomMultipleSelectProps {
    items: ISelectProps[];
    value: any[];
    label: string;
    className?: string;
    loading?: boolean;
    onChange: (value: string | number[]) => void;
    onInputChange?: (event: React.ChangeEvent<{}>, value: string) => void;
    hidden?: boolean;
    noOptionsText?: string;
    disableCloseOnSelect?: boolean;
    defaultLabel?: string;
    disabled?: boolean;
}

const CustomMultipleSelect = ({
                                  items,
                                  value,
                                  label,
                                  className,
                                  loading,
                                  onInputChange,
                                  onChange,
                                  hidden = false,
                                  noOptionsText = 'No options',
                                  disableCloseOnSelect = false,
                                  defaultLabel = 'All',
                                  disabled = false,
                              }: ICustomMultipleSelectProps) => {
    const options = items.map((item: any) => ({
        id: item.id,
        label: item.name,
    }));

    let selectedValues = options.filter((el) => value.includes(el.id));

    if (selectedValues.length === 0) {
        selectedValues = [{id: defaultLabel, label: defaultLabel}];
    }

    return (
        <FormControl className={className}>
            <Autocomplete
                multiple
                disabled={disabled}
                value={selectedValues}
                disableCloseOnSelect={disableCloseOnSelect}
                onInputChange={onInputChange}
                onChange={(_, newValue) => {
                    if (Array.isArray(newValue)) {
                        const values = newValue
                            .filter(({id}) => id !== defaultLabel)
                            .map(({id}) => id);

                        onChange(values);
                    } else {
                        onChange([]);
                    }
                }}
                limitTags={1}
                options={options}
                loading={loading}
                renderInput={(params) => {
                    return <TextField
                        {...params}
                        label={label}
                    />
                }}
                hidden={hidden}
                noOptionsText={noOptionsText}
                getOptionKey={(option) => option.id}
                getOptionLabel={(option) => option.label}
            />
        </FormControl>
    );
};

export default CustomMultipleSelect;
